export default __webpack_public_path__ + "static/media/Megosu - Lukas Bazle - 5.040ea96d.jpg";